import React from 'react';
import { Rocket, Zap, Package, Wrench } from 'lucide-react';
import bannerImage from '../../../../shared/images/bannerimage.png';
import './styles/heading.css';
import './styles/headingMobile.css';

const Heading: React.FC = () => {
  return (
    <div className="hero-content">
      <div className="video-container">
        <iframe
          src="https://imagekit.io/player/embed/phzzoukcb/truckvideo.mp4?controls=false&autoplay=true&muted=true&start=0&end=0.02&loop=true&background=%23000000&updatedAt=1761022054551"
          title="Buildzap Video"
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="hero-video"
        />
      </div>

      <div className="hero-text">
        {/* Badge */}
        <div className="hero-badge">
          <Rocket className="rocket-icon" />
          <span>INDIA'S FIRST</span>
        </div>

        {/* Main Heading */}
        <h1 className="hero-title">
          <span className="title-main">30-Minutes Delivery</span>
          <div className="scrolling-words-container">
            <span className="title-for">For&nbsp;</span>
            <div className="scrolling-words-box">
              <ul>
                <li>Wires</li>
                <li>Adhesives</li>
                <li>Cement</li>
                <li>Bricks</li>
                <li>Tools</li>
                <li>Plumbing</li>
                <li>Pipes</li>
                <li>Putty</li>
                <li>Sanitary</li>
                <li>Paints</li>
                <li>Hardware</li>
              </ul>
            </div>
          </div>
        </h1>

        {/* Description */}
        <p className="hero-description">
          An all in one platform for sourcing construction materials and essentials. <span></span>
        </p>

        {/* Feature List */}
        <div className="hero-features">
          <div className="feature-item">
            <Zap className="feature-icon" />
            <span>30-Minutes Delivery</span>
          </div>
          <div className="feature-item">
            <Package className="feature-icon" />
            <span>No Minimum Quantity</span>
          </div>
          <div className="feature-item">
            <Wrench className="feature-icon" />
            <span>Built for homeowners, contractors, and urgent needs.</span>
          </div>
        </div>
      </div>

      {/* App Showcase Card - visible only on tablet & desktop */}
      <div className="hero-app-showcase">
        <img
          src={bannerImage}
          alt="BuildZap App - Work is ready to start. Materials should be too."
          className="hero-app-showcase-img"
        />
      </div>
    </div>
  );
};

export default Heading;